<template>
  <div
    :class="{
      'error-card': error.type === 'Error',
      'warning-card': error.type === 'Warning',
      dense: dense,
      'use-color': useColor,
    }"
  >
    <v-row dense>
      <v-col cols="1" style="line-height: 32px"
        ><v-icon color="darkred">mdi-alert-outline</v-icon></v-col
      >
      <v-col>
        <vs-text bold style="line-height: 32px" color="darkred">{{ error.code }}</vs-text>
        <vs-text style="font-size: 14px; line-height: 18px">{{ error.details }}</vs-text>
      </v-col>
    </v-row>
    <v-row dense v-if="seeMoreButton">
      <v-col>
        <div v-ripple class="see-more" @click="handleSeeMore">See more</div>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import VsText from '@/components/vision/VsText.vue'
import { SyncErrors } from '@/models/batch'

const props = defineProps<{
  error: SyncErrors
  seeMoreButton?: boolean
  dense?: boolean
  useColor?: boolean
}>()

const emit = defineEmits<{
  (e: 'expand')
}>()

const handleSeeMore = () => {
  emit('expand')
  console.log('expand')
}
</script>

<style scoped>
.error-card,
.warning-card {
  margin: var(--space-base) var(--space-small);
  padding: var(--space-smaller) var(--space-base);
  border-radius: var(--space-smaller);

  &.dense {
    margin: var(--space-small) 0;
    padding: var(--space-smallest) var(--space-base);
  }
}

.error-card {
  border-left: solid 4px darkred;

  &.use-color {
    background-color: #ffeeee;
  }
}

.warning-card {
  border-left: solid 4px #ffbe3c;

  &.use-color {
    background-color: #fff7e2;
  }
}

.see-more {
  font-size: 14px;
  line-height: 18px;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
  padding: 4px;
}
</style>
